import { useIntl } from 'react-intl';
import { Button, Flex } from '@mantine/core';
import { ErrorModal, ModuleView } from '@jadwalh/ui';
import { SectionContainer } from './styles';
import { ReactComponent as Zoom } from '../../../../../assets/images/svg/zoom.svg';
import { useSelector } from 'react-redux';
import { getProfileData } from '../../../../../store/profile.slice';
import { useState } from 'react';

export default function ZohoCRM() {
  const { formatMessage } = useIntl();
  const profile = useSelector(getProfileData);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const handleClick = () => {
    if (profile.role.role_value === 2) {
      setShowErrorModal(true);
    }
  };

  return (
    <SectionContainer>
      <ModuleView>
        <Flex
          direction={{ base: 'column' }}
          align={{ base: 'flex-start' }}
          className="detail_container"
        >
          <Flex justify="center" align="center" gap="10px">
            <Zoom style={{ width: '20px', height: '20px' }} />
            <p className="SemiBold title">Zoom</p>
          </Flex>
          <Flex direction={'column'} gap={'16px'} w={'100%'} pt={'16px'}>
            <Flex
              direction={'column'}
              align={'space-between'}
              justify={'space-between'}
              className="info"
            >
              <p>{formatMessage({ id: 'integrations.zohoCrm.description' })}</p>
              <br />
              <p>{formatMessage({ id: 'integrations.zohoCrm.benefits' })}</p>
              <Flex direction={'column'} gap={'0'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({ id: 'integrations.zohoCrm.benefit1.title' })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.zohoCrm.benefit1.description',
                  })}
                </p>
              </Flex>
              <Flex direction={'column'} gap={'0'} mt={'12px'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({ id: 'integrations.zohoCrm.benefit2.title' })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.zohoCrm.benefit2.description',
                  })}
                </p>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </ModuleView>
      <Button onClick={handleClick}>
        {formatMessage({ id: 'activation' })}
      </Button>
      {showErrorModal && (
        <ErrorModal
          showErrorModal={showErrorModal}
          setShowErrorModal={setShowErrorModal}
          message={formatMessage({ id: 'integrations.zohoCrm.error' })}
        />
      )}
    </SectionContainer>
  );
}
